export const cx = (...classes: Array<string | false | null | undefined>): string => classes.filter(Boolean).join(" ");

const DEPARTMENT_PALETTE = [
	{ bg: "#d8edf6", fg: "#24516b", dot: "#2f7ea8" },
	{ bg: "#dff6ea", fg: "#11613c", dot: "#2f9d63" },
	{ bg: "#fff0ca", fg: "#8a5600", dot: "#d79516" },
	{ bg: "#ffe2e6", fg: "#98213f", dot: "#d7435f" },
	{ bg: "#e8e2ff", fg: "#5b3ab5", dot: "#7356d6" },
	{ bg: "#d5f5f7", fg: "#14606a", dot: "#23a4ad" },
	{ bg: "#e0f0ff", fg: "#1f5a8a", dot: "#2c79b2" },
	{ bg: "#fde3f0", fg: "#9a2f66", dot: "#d14c8b" },
	{ bg: "#ecf7d4", fg: "#4f6b13", dot: "#7aa62a" },
	{ bg: "#ffe3cc", fg: "#8d4315", dot: "#dc7a2e" },
];

export const getDepartmentPalette = (department: string) => {
	let hash = 0;
	for (let index = 0; index < department.length; index += 1) {
		hash = department.charCodeAt(index) + (hash << 5) - hash;
	}
	return DEPARTMENT_PALETTE[Math.abs(hash) % DEPARTMENT_PALETTE.length]!;
};
